(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('LotGridDTO', LotGridDTO);

    LotGridDTO.$inject = ['$resource','DateUtils'];

    function LotGridDTO($resource, DateUtils) {
        var resourceUrl = "api/lotGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
